import {Card, Col, Row} from "react-bootstrap";
import resourceData from "./ResourcesReferenceData";
import DocumentPublicDownload from "../../../Components/Documents/DocumentPublicDownload";
import {setGlobalErrorStatus} from "../../../Components/StatusHandling";
import {ERROR_MESSAGES} from "../../../Utils/constants";
import {useDispatch} from "react-redux";

const ResourcesReference = () => {
  const dispatch = useDispatch();
  
  const errorHandle = function () {
    setGlobalErrorStatus({
      dispatch: dispatch,
      popupData: {
        visible: true,
        title: ERROR_MESSAGES.GENERAL_ERROR.title,
        msg: ERROR_MESSAGES.GENERAL_ERROR.message,
        showContactHelp: true
      },
      redirect: {
        redirect: false,
        redirectFirst: false,
        path: "",
        data: {}
      }
    })
  };
  
  return (
    <>
      {/*<Row className="justify-content-center resources-reference m-0 p-0">*/}
      <Row className="resources-reference align-items-center align-content-center ">
        <Col xl={11} lg={11} md={12} sm={12}>
          <Card className="p-4">
            <Card.Body className="text-start">
              <h1 className="header1 pb-2 " id="mainContent"> Resources </h1>
              <p className="body pb-4">This references section includes documents that provide information regarding the activities conducted by the Patient Safety Privacy Protection Center (PSOPPC) in support of the Patient Safety Organizations (PSOs).</p>
              <h2 className="header2 separator-underline">SAFER Guides</h2>
              <p className="body pt-2">The Office of the National Coordinator for Health Information Technology (ONC) developed the Safety Assurance Factor for EHR Resilience (SAFER) Guides to assist all electronic health records (EHR) users, developers, and PSOs conduct self-assessments to optimize the safety and safe use of EHRs. The SAFER Guides include assessments and recommended practices in nine areas from the different categories. PSOs are encouraged to start with the Foundational Guides, and proceed from there to address their specific areas of concern or interest.</p>
              <p className="body">To learn more about SAFER Guides, please visit <a href={`https://www.healthit.gov/topic/safety/safer-guides`} target={`_blank`} className={`external-link`}>HealthIT.gov</a> for more information.</p>
              <h3 className="header3 pt-2">Foundational Guides</h3>
              <div className={`pb-4`}>
              {resourceData.saferGuides.foundational.map((groupId) => (
                <div className={`pt-1`}>
                  <DocumentPublicDownload groupId={groupId} pageName="Resources" errorHandle={errorHandle}/>
                </div>
              ))}
              </div>
              <h3 className="header3 pt-2">Infrastructure Guides</h3>
              <div className={`pb-4`}>
              {resourceData.saferGuides.infrastructure.map((groupId) => (
                <div className={`pt-1`}>
                  <DocumentPublicDownload groupId={groupId} pageName="Resources" errorHandle={errorHandle}/>
                </div>
              ))}
              </div>
              <h3 className="header3 pt-2">Clinical Process Guides</h3>
              <div className={`pb-4`}>
              {resourceData.saferGuides.clinicalProcess.map((groupId) => (
                <div className={`pt-1`}>
                  <DocumentPublicDownload groupId={groupId} pageName="Resources" errorHandle={errorHandle}/>
                </div>
              ))}
              </div>
              <h2 className="header2 separator-underline pt-3">PSO Annual Meeting Presentations</h2>
              <h3 className="header3 pt-2">15th PSO Annual Meeting Day 1</h3>
              <p className="body pt-1">The full handouts and all speaker presentations from the 15th PSO Annual Meeting are included below.</p>
              <div className={`pb-4`}>
              {resourceData.annualMeeting.fifteenDay1.map((groupId) => (
                <div className={`pt-1`}>
                  <DocumentPublicDownload groupId={groupId} pageName="Resources" errorHandle={errorHandle}/>
                </div>
              ))}
              </div>
              <h3 className="header3 pt-2">15th PSO Annual Meeting Day 2</h3>
              <div className={`pb-4`}>
              {resourceData.annualMeeting.fifteenDay2.map((groupId) => (
                <div className={`pt-1`}>
                  <DocumentPublicDownload groupId={groupId} pageName="Resources" errorHandle={errorHandle}/>
                </div>
              ))}
              </div>
              <h3 className="header3 pt-2">11th PSO Annual Meeting Day 1</h3>
              <p className="body pt-1">The full handouts and all speaker presentations from the 11th PSO Annual Meeting are included below.</p>
              <div className={`pb-4`}>
              {resourceData.annualMeeting.elevenDay1.map((groupId) => (
                <div className={`pt-1`}>
                  <DocumentPublicDownload groupId={groupId} pageName="Resources" errorHandle={errorHandle}/>
                </div>
              ))}
              </div>
              <h3 className="header3 pt-2">11th PSO Annual Meeting Day 2</h3>
              <div className={`pb-4`}>
              {resourceData.annualMeeting.elevenDay2.map((groupId) => (
                <div className={`pt-1`}>
                  <DocumentPublicDownload groupId={groupId} pageName="Resources" errorHandle={errorHandle}/>
                </div>
              ))}
              </div>
              <h2 className="header2 separator-underline pt-3">PSO Quarterly Call Presentations</h2>
              <p className="body pt-2">The PSO Quarterly Call presentations are posted below.</p>
              <div className={`pb-4`}>
              {resourceData.quarterlyCall.map((groupId) => (
                <div className={`pt-1`}>
                  <DocumentPublicDownload groupId={groupId} pageName="Resources" errorHandle={errorHandle}/>
                </div>
              ))}
              </div>
              <h2 className="header2 separator-underline pt-3">PSO Summit to Address the Opioid Crisis</h2>
              <p className="body pt-2">The PSO Summit to Address the Opioid Crisis presentations are posted below.</p>
              {resourceData.opioidCrisis.map((groupId) => (
                <div className={`pt-1`}>
                  <DocumentPublicDownload groupId={groupId} pageName="Resources" errorHandle={errorHandle}/>
                </div>
              ))}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );

}

export default ResourcesReference;